// frontend/src/services/language/languageService.js
import api from '../api';

/**
 * Language Service - Handles language-related operations
 */
class LanguageService {
  /**
   * Get all supported languages for translation
   * @returns {Promise<Array>} - Promise that resolves with the languages
   */
  async getLanguages() {
    try {
      const response = await api.get('/languages');
      return response.data;
    } catch (error) {
      console.error("Error fetching languages:", error);
      // Return default English only if API call fails
      return [{ code: 'en', name: 'English' }];
    }
  }
}

export default new LanguageService();